import {
  BlankSlate,
  BlankSlateActions,
  BlankSlateIcon,
  BlankSlateTitle,
  Box,
  Button,
  Card,
  CardContent
} from "@prismicio/editor-ui"
import { useState } from "react"

import type { MediaAssetOrExternalImage } from "../../../core/MediaLibrary/hooks/mediaLibraryData"
import { MediaDialog } from "../MediaDialog"

interface EmptyCardContentProps {
  isUpdating: boolean
  readOnly: boolean
  onMediaSelected: (media: MediaAssetOrExternalImage) => void
}

export function EmptyCardContent(props: EmptyCardContentProps) {
  const { onMediaSelected, readOnly, isUpdating } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <CardContent>
      <Card color="grey3" variant="outlined" radius={4}>
        <CardContent>
          <Box padding={{ block: 48 }} flexDirection="column">
            <BlankSlate>
              <BlankSlateIcon name="cloudUpload" />
              <BlankSlateTitle>
                {isUpdating
                  ? "Preparing your image..."
                  : "You haven't selected an image"}
              </BlankSlateTitle>
              {!readOnly && (
                <BlankSlateActions>
                  <Button disabled={isUpdating} onClick={() => setIsOpen(true)}>
                    Select image
                  </Button>
                </BlankSlateActions>
              )}
            </BlankSlate>
          </Box>
        </CardContent>
      </Card>
      <MediaDialog
        open={isOpen}
        onOpenChange={setIsOpen}
        onMediaSelected={onMediaSelected}
        assetType="image"
      />
    </CardContent>
  )
}
